import { defineStore } from 'pinia'
import * as accountApi from '@/network/api/accounts.api.js'
import * as beneficiariesApi from '@/network/api/transfers/beneficiaries.api.js'
import * as transfersApi from '@/network/api/transfers/transfers.api.js'
import * as recurringApi from '@/network/api/transfers/recurring.api.js'
import * as interbankApi from '@/network/api/transfers/interbank.api.js'
import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

export const useTransfersPeriodicStore = defineStore('transfersPeriodicStore', {
    state: () => ({
        accountsBalances: [],
        recurringTransfers: [],
        recurringInterbankTransfers: [],
        scheduleTypes: [],
        lastRecurringTransfersInfo: {},
        lastInterbankRecurringTransfersInfo: {},
        recurringTransfersHasMore: false,
        beneficiaryName: null,
        transfersCategoriesList: [],
        transfersMotivesList: [],
        recurringInterbankTransfersHasMore: false,
        selectedPeriodicAccountId: null
    }),
    getters: {
        getAccountsBalances: (state) => parseAccountsForFeature(state.accountsBalances),
        getRecurringTransfers: (state) => state.recurringTransfers,
        getInterbankRecurringTransfers: (state) => state.recurringInterbankTransfers,
        getScheduleTypes: (state) => state.scheduleTypes,
        getBeneficiaryName: (state) => state.beneficiaryName,
        getLastRecurringTransfersInfo: (state) => state.lastRecurringTransfersInfo,
        getLastInterbankRecurringTransfersInfo: (state) => state.lastInterbankRecurringTransfersInfo,
        getRecurringTransfersHasMore: (state) => state.recurringTransfersHasMore,
        getTransfersCategoriesList: (state) => state.transfersCategoriesList,
        getTransfersMotivesList: (state) => state.transfersMotivesList,
        getInterbankRecurringTransfersHasMore: (state) => state.recurringInterbankTransfersHasMore,
        getSelectedPeriodicAccountId: (state) => state.selectedPeriodicAccountId
    },
    actions: {
        async requestAccountsBalances(payload) {
            const res = await accountApi.requestAccountsBalances(payload)
            if (res) this.accountsBalances = res.data.data.balanceViews
            return res
        },
        async requestRecurringTransfers(payload) {
            const res = await recurringApi.requestRecurringTransfers(payload)
            if (res) {
                const data = res.data.data
                this.recurringTransfers = payload.pageNumber === 1 ? data.transfers : this.recurringTransfers.concat(data.transfers)
                this.lastRecurringTransfersInfo = { currentPageToken: data.currentPageToken }
                this.recurringTransfersHasMore = data.hasMore
            }
            return res
        },
        async requestInterbankRecurringTransfersList(payload) {
            const res = await interbankApi.getInterbankRecurringTransfersList(payload)
            if (res) {
                const data = res.data.data
                this.recurringInterbankTransfers = payload.pageNumber === 1 ? data.transfers : this.recurringInterbankTransfers.concat(data.transfers)
                this.lastInterbankRecurringTransfersInfo = { currentPageToken: data.currentPageToken, searchKey: data.searchKey }
                this.recurringInterbankTransfersHasMore = data.hasMore
            }
            return res
        },
        async requestBeneficiaryName(payload) {
            const res = await beneficiariesApi.getBeneficiaryDestinationInfo(payload)
            if (res) this.beneficiaryName = res.data.data.firstHolderName
            return res
        },
        async requestScheduleTypes(payload) {
            const res = await transfersApi.getTransfersScheduleTypes(payload)
            if (res) this.scheduleTypes = res.data.data
            return res
        },
        async editRecurringTransfer(payload) {
            const res = await recurringApi.editRecurringTransfer(payload)
            return res
        },
        async editInterbankRecurringTransfer(payload) {
            const res = await interbankApi.editInterbankRecurringTransfer(payload)
            return res
        },
        async deleteRecurringTransfer(payload) {
            const res = await recurringApi.deleteRecurringTransfer(payload)
            return res
        },
        async requestTansfersCategoriesList(payload) {
            const res = await transfersApi.getTransfersCategoriesList(payload)
            if (res) {
                const data = res.data.data
                this.transfersCategoriesList = data
            }
            return res
        },
        async requestTransfersMotivesList(payload) {
            const res = await transfersApi.getTransfersMotivesListForTransferCategory(payload)
            if (res) {
                const data = res.data.data
                this.transfersMotivesList = data
            }
            return res
        },
        async deleteInterbankRecurringTransfer(payload) {
            const res = await interbankApi.deleteInterbankRecurringTransfer(payload)
            return res
        },
        saveSelectedPeriodicAccountId(payload) {
            this.selectedPeriodicAccountId = payload
        },
        clearFeatureStates() {
            this.accountsBalances = []
            this.recurringTransfers = []
            this.recurringInterbankTransfers = []
            this.scheduleTypes = []
            this.lastRecurringTransfersInfo = {}
            this.lastInterbankRecurringTransfersInfo = {}
            this.recurringTransfersHasMore = false
            this.recurringInterbankTransfersHasMore = false
            this.beneficiaryName = null
            this.transfersCategoriesList = []
            this.transfersMotivesList = []
        }
    }
})
